(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tribal-backing-choice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tribal-backing-choice')) {
  customElements.define('tribal-backing-choice', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.product__info-container');
      this.blocked = new Set(JSON.parse(this.dataset.blockedIds).map(String));
      this.onChange = () => queueMicrotask(() => this.refresh());
      this.onPurchase = (event) => {
        const purchase = event.type === 'submit' ? event.target.closest('product-form') : event.target.closest('product-form button[type="submit"]');
        if (!purchase || !this.isIncomplete()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.refresh();
        this.querySelector('[role="status"]').focus();
      };
      this.root.addEventListener('change', this.onChange);
      this.root.addEventListener('submit', this.onPurchase, true);
      this.root.addEventListener('click', this.onPurchase, true);
      queueMicrotask(() => this.refresh());
    }
    isIncomplete() {
      const input = this.root.querySelector('product-form [name="id"]');
      return input ? this.blocked.has(input.value) : this.hasAttribute('data-incomplete');
    }
    refresh() {
      this.toggleAttribute('data-incomplete', this.isIncomplete());
    }
    disconnectedCallback() {
      this.root?.removeEventListener('change', this.onChange);
      this.root?.removeEventListener('submit', this.onPurchase, true);
      this.root?.removeEventListener('click', this.onPurchase, true);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tribal-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tribal-film')) {
  customElements.define('tribal-film', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      const action = this.querySelector('[data-film-action]');
      const error = this.querySelector('[role="status"]');
      if (!video || !button) return;
      const label = video.getAttribute('aria-label') || '';
      const update = () => {
        const text = video.ended ? button.dataset.replay : video.paused ? button.dataset.play : button.dataset.pause;
        action.textContent = text;
        button.setAttribute('aria-label', `${text}: ${label}`);
      };
      const failed = () => { error.hidden = false; update(); };
      const toggle = () => {
        video.controls = true;
        error.hidden = true;
        if (video.paused) video.play().catch(failed);
        else video.pause();
      };
      const play = () => {
        document.querySelectorAll('tribal-film video').forEach(other => {
          if (other !== video && !other.paused) other.pause();
        });
        update();
      };
      const visibility = () => { if (document.hidden) video.pause(); };
      const posterClick = () => { if (!video.controls) toggle(); };
      video.controls = false;
      button.hidden = false;
      video.addEventListener('click', posterClick);
      button.addEventListener('click', toggle);
      video.addEventListener('play', play);
      video.addEventListener('pause', update);
      video.addEventListener('ended', update);
      video.addEventListener('error', failed);
      document.addEventListener('visibilitychange', visibility);
      this.cleanup = () => {
        video.pause();
        video.removeEventListener('click', posterClick);
        button.removeEventListener('click', toggle);
        video.removeEventListener('play', play);
        video.removeEventListener('pause', update);
        video.removeEventListener('ended', update);
        video.removeEventListener('error', failed);
        document.removeEventListener('visibilitychange', visibility);
      };
    }
    disconnectedCallback() {
      if (this.cleanup) this.cleanup();
      this.cleanup = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
